
import * as d3 from 'd3';
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import StoreModules from '../store/store-modules';

@Component({
  name: 'TimeViewComponent',
  props: ['activity', 'selectedDate'],
  computed: {
    ...mapGetters(StoreModules.CUSTOMER, ['companyInformation']),
    ...mapGetters(StoreModules.APPOINTMENT, ['roomAv', 'employeeAv'])
  }
})
export default class TimeViewComponent extends Vue {
  public companyInformation!: any;
  public roomAv!: Array<any>;
  public employeeAv!: Array<any>;

  public activity!: any;
  public selectedDate!: any;

  times: Array<any> = [];
  slots = [];
  showError = false;
  tabCount = 0;
  splittedTimes:Array<any> = [];

  beforeMount () {
    this.onLoad();
  }

  get customHoverColor () {
    return {
      background: this.companyInformation.ColorHex,
      color: this.companyInformation.HeadColor
    };
  }

  @Watch('employeeAv')
  employeeAvChanged () {
    this.loadTimes();
  }

  @Watch('roomAv')
  roomAvChanged () {
    this.loadTimes();
  }

  @Watch('selectedDate')
  selectedDateChanged () {
    this.loadTimes();
  }

  @Watch('activity')
  activityChanged () {
    this.loadTimes();
  }

  onLoad () {
    this.loadTimes();
  }

  timeClick (time: any) {
    const response = {
      RoomID: time.RoomID,
      EmployeeID: time.EmployeeID,
      Date: time.Date
    };

    this.$emit('timeClick', response);
  }

  loadTimes () {
    const time = [];
    let Estart;
    let Eend;
    let Rstart;
    let Rend;
    let EmployeeIDOfInterval = 0;
    let roundedStart;
    let date;
    const slotpitch = this.companyInformation.SlotPitch;
    const x = this.employeeAv.length;
    const y = this.roomAv.length;
    let i;
    let j;
    const coeff = 1000 * 60 * parseInt(this.companyInformation.SlotPitch);

    for (i = 0; i < x; i++) {
      date = this.$moment(this.employeeAv[i].AvailStart).locale('de');
      roundedStart = this.$moment(Math.ceil(date.valueOf() / coeff) * coeff);

      Estart = this.$moment(roundedStart);
      Eend = this.$moment(this.employeeAv[i].AvailEnd).locale('de'); // End mussend be roundet because the Timeslots get splitet into Slots of the Duration lenght
      EmployeeIDOfInterval = this.employeeAv[i].EmployeeID;

      for (j = 0; j < y; j++) {
        const dater = this.$moment(this.roomAv[j].AvailStart).locale('de');
        const roundedStartR = new Date(Math.ceil(dater.valueOf() / coeff) * coeff);

        Rstart = this.$moment(roundedStartR);
        Rend = this.$moment(this.roomAv[j].AvailEnd).locale('de'); // End mussend be roundet because the Timeslots get splitet into Slots of the Duration lenght if needed can be done with Math.floor()

        // eslint-disable-next-line no-empty
        if (Estart.valueOf() < Rstart.valueOf() && Eend.valueOf() < Rstart.valueOf()) {
        // eslint-disable-next-line no-empty
        } else if (Estart.valueOf() >= Rstart.valueOf() && Estart.valueOf() >= Rend.valueOf()) {
        } else if (Estart.valueOf() <= Rstart.valueOf() && Eend.valueOf() <= Rend.valueOf()) {
          time.push({
            Starthour: Rstart.format('HH'),
            Startmin: Rstart.format('mm'),
            Endhour: Eend.format('HH'),
            Endmin: Eend.format('mm'),
            EmployeeID: EmployeeIDOfInterval,
            RoomID: this.roomAv[j].RoomID
          });
        } else if (Estart.valueOf() <= Rstart.valueOf() && Eend.valueOf() >= Rend.valueOf()) {
          time.push({
            Starthour: Rstart.format('HH'),
            Startmin: Rstart.format('mm'),
            Endhour: Rend.format('HH'),
            Endmin: Rend.format('mm'),
            EmployeeID: EmployeeIDOfInterval,
            RoomID: this.roomAv[j].RoomID
          });
        } else if (Estart.valueOf() >= Rstart.valueOf() && Eend.valueOf() >= Rend.valueOf()) {
          time.push({
            Starthour: Estart.format('HH'),
            Startmin: Estart.format('mm'),
            Endhour: Rend.format('HH'),
            Endmin: Rend.format('mm'),
            EmployeeID: EmployeeIDOfInterval,
            RoomID: this.roomAv[j].RoomID
          });
        } else if (Estart.valueOf() >= Rstart.valueOf() && Eend.valueOf() <= Rend.valueOf()) {
          time.push({
            Starthour: Estart.format('HH'),
            Startmin: Estart.format('mm'),
            Endhour: Eend.format('HH'),
            Endmin: Eend.format('mm'),
            EmployeeID: EmployeeIDOfInterval,
            RoomID: this.roomAv[j].RoomID
          });
        }
      }
    }

    const slot = [];
    for (i = 0; i < time.length; i++) {
      const Start = new Date(
        this.$moment(this.selectedDate).year(),
        this.$moment(this.selectedDate).month(),
        this.$moment(this.selectedDate).day() + 1,
        time[i].Starthour,
        time[i].Startmin
      );
      const End = new Date(
        this.$moment(this.selectedDate).year(),
        this.$moment(this.selectedDate).month(),
        this.$moment(this.selectedDate).day() + 1,
        time[i].Endhour,
        time[i].Endmin
      );
      const slot1 = d3.timeMinute.range(Start, End, slotpitch);

      for (let s = 0; s < slot1.length; s++) {
        const count = d3.timeMinute.count(slot1[s], End);

        if (count >= this.activity.Duration) {
          const dd = this.$moment(this.selectedDate);
          dd.set({
            hour: this.$moment(slot1[s]).hour(),
            minute: this.$moment(slot1[s]).minute()
          });
          const ddFormat = dd.format('DD-MM-YYYY HH:mm');

          let add = true;

          for (let k = 0; k < slot.length; k++) {
            // eslint-disable-next-line
            if (slot[k].Date == dd.format('DD-MM-YYYY HH:mm')) add = false;
          }
          if (add) {
            slot.push({
              Date: ddFormat,
              CompareDate: slot1[s],
              Index: slot.length,
              StartTime: this.$moment(slot1[s]).format('HH:mm'),
              EndTime: this.$moment(this.$moment(slot1[s]).add(this.activity.Duration, 'minutes')).format('HH:mm'),
              EmployeeID: time[i].EmployeeID,
              RoomID: time[i].RoomID
            });
          }
        }
      }
    }

    slot.sort(function (a: any, b: any) {
      return a.CompareDate - b.CompareDate;
    });

    this.times = slot.filter((el, i, a) => i === a.indexOf(el));

    const currentDate = new Date();

    if (currentDate.getDate() === this.selectedDate.getDate() &&
      currentDate.getMonth() === this.selectedDate.getMonth() &&
      currentDate.getFullYear() === this.selectedDate.getFullYear()) {
      this.times = this.times.filter((el) => {
        const dd = this.$moment(el.Date, 'DD-MM-YYYY HH:mm').toDate();
        return dd > currentDate;
      });
    }
    this.showError = this.times.length === 0;

    this.tabCount = parseInt((this.times.length / 6).toString());

    if (this.tabCount === 0 && this.times.length > 0) this.tabCount = 1;

    const rest = this.times.length % 6;

    this.splittedTimes = [];

    for (let i = 0; i < this.tabCount; i++) {
      if (i !== this.tabCount - 1) {
        this.splittedTimes[i] = this.times.slice(i * 6, 6 * (i + 1));
      } else {
        this.splittedTimes[i] = this.times.slice(i * 6, parseInt((6 * (i + 1) + rest).toString()));
      }
    }
    this.$forceUpdate();
  }
};
